export default function passwordService() {
  return function generate(viewField, engineApi) {
    return engineApi.field.generateInput(viewField, engineApi, 'password');
  };
}
